import { HTMLAttributes } from 'react';
import styled, { css, keyframes } from 'styled-components';

// theme
import { color } from 'theme/selectors';

export const SideBarWrapper = styled.div<{ $isOpen: boolean } & HTMLAttributes<HTMLDivElement>>`
    position: fixed;
    top: 57px;
    left: 0;
    width: 100vw;
    height: calc(100vh - 56px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
    z-index: 10000;

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            opacity: 1;
            visibility: visible;

            ${SideBarOverlay} {
                opacity: 0.8;
            }

            ${SideBarMenu} {
                left: 0;
            }
        `}
`;

export const SideBarOverlay = styled.div<HTMLAttributes<HTMLDivElement>>`
    width: 100vw;
    height: 100vh;
    background: ${color('surface-main')};
    opacity: 0;
    transition: opacity 0.4s ease;
`;

export const SideBarMenu = styled.div`
    position: absolute;
    top: 0;
    left: -100%;
    display: flex;
    flex-direction: column;
    width: 260px;
    height: 100%;
    padding: 32px 16px;
    box-shadow: 0 4px 12px rgb(0 0 0 / 12%);
    background: ${color('surface-main')};
    transition: all 0.3s;
    overflow: scroll;
`;

export const Hr = styled.div`
    margin-bottom: 24px;
    width: 100%;
    min-height: 1px;
    background-color: ${color('border-default')};
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    15% { transform: rotate(54deg); }
    100% { transform: rotate(360deg); }
`;

export const NavButton = styled.button<{ $isLoading?: boolean } & React.ButtonHTMLAttributes<HTMLButtonElement>>`
    position: relative;
    display: flex;
    align-items: center;
    background: transparent;
    cursor: pointer;
    padding: 8px 0;
    margin-bottom: 8px;
    text-align: left;

    > p:hover {
        color: ${color('text-main')};
    }

    & img {
        margin-left: 8px;
    }

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            pointer-events: none;
            opacity: 0.6;

            &::after {
                content: '';
                display: inline-block;
                margin-left: 8px;
                width: 12px;
                height: 12px;
                border: 2px solid ${color('text-main')};
                border-top-color: transparent;
                border-radius: 50%;
                animation: ${spin} 1.2s linear infinite;
                flex-shrink: 0;
            }
        `}
`;

export const RedDot = styled.div`
    width: 10px;
    height: 10px;
    margin-left: 9px;
    border-radius: 100%;
    background-color: ${color('discount')};
`;
